import Vue from 'vue';
import Router from 'vue-router';
import Devices from './views/Devices';
import Flows from './views/Flows';
import FlowCreate from './views/FlowCreate';
import Boot from './views/Boot';
import Insights from './views/Insights';
import Login from './views/Login';
import LoginCallback from './views/LoginCallback';
import Settings from './views/Settings';
import SelectHomey from './views/SelectHomey';
import Help from './views/Help';
//import Sandbox from './views/Sandbox';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			name: 'boot',
			component: Boot,
		},
		{
			path: '/devices',
			name: 'devices',
			component: Devices,
		},
		{
			path: '/flow',
			name: 'flow',
			component: Flows,
		},
		{
			path: '/flow/create',
			name: 'flow-create',
			component: FlowCreate,
		},
		{
			path: '/insights',
			name: 'insights',
			component: Insights,
		},
		{
			path: '/settings',
			name: 'settings',
			component: Settings,
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			props: true
		},
		{
			path: '/oauth2/callback',
			name: 'callback',
			component: LoginCallback,
		},
		{
			path: '/homeys',
			name: 'homeys',
			component: SelectHomey,
			props: true
		},
		{
			path: '/help',
			name: 'help',
			component: Help,
			props: true
		},
//		{
//			path: '/_sandbox',
//			name: '_sandbox',
//			component: Sandbox,
//		},
	],
});
